import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
} from "@material-ui/core";
import { LIST_CHAT_SDK_PACKAGE_STATUS } from "constant/ticket";
import datetimeHelper from "helper/datetime-helper";
import { useSnackbar } from "notistack";
import { useSelector } from "react-redux";

import DialogDragable from "../../../components/DialogDragable";

const PackageInfo = ({ open, onClose, loading, packageInfo, packageCode }) => {
  const { ringmeOttSdk } = useSelector((state) => state.ringmeOttSdk);
  const { enqueueSnackbar } = useSnackbar();

  const chatSdkPackageStatus = packageInfo?.phat?.trang_thai
    ? LIST_CHAT_SDK_PACKAGE_STATUS.filter((item) => item.title).find((item) =>
        packageInfo.phat.trang_thai
          .toLowerCase()
          .includes(item.title.toLowerCase())
      )
    : null;

  let orderInfo = {
    id: packageCode,
    ship_cod: packageInfo?.info?.tien_cod,
    ship_fee: null,
    orderDetail: `Tên người gửi: ${packageInfo?.info?.ten_nguoi_gui || ""}`,
    orderType: 1,
    orderState: chatSdkPackageStatus?.chatSdkTitle ?? null,
    statusCode: chatSdkPackageStatus?.code ?? null,
  };

  const handleChatToPhoneNumber = (phoneNumber) => {
    console.log(orderInfo);
    const typeQuestion = 0;
    try {
      ringmeOttSdk.openChat(
        phoneNumber,
        JSON.stringify(orderInfo),
        typeQuestion
      );
    } catch (err) {
      console.log(err);
    }
    onClose();
  };

  const handleChatToPostOffice = (postOffice, jidQueue) => {
    console.log("jidQueue", jidQueue);
    console.log("postOffice", postOffice);
    if (!jidQueue) {
      enqueueSnackbar("Hàng đợi chat chưa được khai báo!", {
        variant: "error",
      });
      return;
    }

    if (postOffice?.split("-").length >= 2) {
      const postOfficeId = postOffice.split("-")[0].trim();
      const postOfficeName = postOffice
        .split("-")
        .slice(1)
        .map((item) => item.trim())
        .join(" ");

      let queueInfo = {
        idQueue: postOfficeId,
        dispName: postOfficeName,
        jidQueue: jidQueue,
        typeQueue: "Bưu cục",
      };

      ringmeOttSdk.openChatQueue(
        JSON.stringify(queueInfo),
        JSON.stringify(orderInfo),
        0
      );
    }

    onClose();
  };

  return (
    <DialogDragable
      open={open}
      onClose={onClose}
      title={
        <span>
          Thông tin bưu gửi{" "}
          <span style={{ fontSize: 20, color: "red" }}>{packageCode}</span>
        </span>
      }
      isLoading={loading}>
      <Grid
        container
        spacing={24}
        style={{ marginTop: 3, marginBottom: 3, padding: 20 }}>
        <Grid
          item
          md={3}
          xs={12}
          style={{
            borderLeft: "1px solid #eee",
            borderRight: "1px solid #eee",
            borderTop: "1px solid #eee",
          }}>
          <h5 style={{ fontSize: 18, color: "red" }}>Thông tin người gửi</h5>
          <InfoField
            title="Tên người gửi"
            value={packageInfo?.info?.ten_nguoi_gui || ""}
          />
          <InfoFieldPhoneNumber
            title="Số điện thoại"
            value={packageInfo?.info?.sdt_nguoi_gui || ""}
            onClickPhoneNumber={ringmeOttSdk ? handleChatToPhoneNumber : null}
          />
          <InfoField
            title="Địa chỉ gửi"
            value={packageInfo?.info?.dia_chi_gui || ""}
          />
          <h5 style={{ fontSize: 18, color: "red", marginTop: 9 }}>
            Thông tin người nhận
          </h5>
          <InfoField
            title="Tên người nhận"
            value={packageInfo?.info?.ten_nguoi_nhan || ""}
          />
          <InfoFieldPhoneNumber
            title="Số điện thoại"
            value={packageInfo?.info?.sdt_nguoi_nhan || ""}
            onClickPhoneNumber={ringmeOttSdk ? handleChatToPhoneNumber : null}
          />
          <InfoField
            title="Địa chỉ nhận"
            value={packageInfo?.info?.dia_chi_nhan || ""}
          />
        </Grid>
        <Grid
          item
          md={3}
          xs={12}
          style={{
            borderLeft: "1px solid #eee",
            borderRight: "1px solid #eee",
            borderTop: "1px solid #eee",
          }}>
          <h5 style={{ fontSize: 18, color: "red" }}>Thông tin bưu gửi</h5>
          <InfoField
            title="Nội dung"
            value={packageInfo?.info?.noi_dung || ""}
          />
          <InfoField
            title="Dịch vụ GTGT(VAS)"
            value={packageInfo?.info?.dich_vu_vas || ""}
          />
          <InfoField title="COD" value={packageInfo?.info?.cod || ""} />
          <InfoField
            title="Tiền COD"
            value={packageInfo?.info?.tien_cod || ""}
          />
          <InfoFieldPostOffice
            title="Bưu cục gửi"
            value={packageInfo?.info?.buu_cuc_gui || ""}
            onClickPostOffice={
              ringmeOttSdk
                ? (postOffice) =>
                    handleChatToPostOffice(
                      postOffice,
                      packageInfo?.ott?.jqid_buu_cuc_gui
                    )
                : null
            }
          />
          <InfoField
            title="Vị trí"
            value={packageInfo?.info?.buu_cuc_phat || ""}
          />
          <InfoField
            title="Ngày cấp nhận"
            value={
              packageInfo?.info?.ngay_nhan
                ? datetimeHelper.toFormat(
                    packageInfo.info.ngay_nhan,
                    "YYYY-MM-DD HH:mm:ss"
                  )
                : ""
            }
          />
          <InfoField
            title="Khối lượng"
            value={
              packageInfo?.info?.khoi_luong
                ? `${packageInfo?.info?.khoi_luong} (g)`
                : ""
            }
          />
        </Grid>
        <Grid
          item
          md={3}
          xs={12}
          style={{
            borderTop: "1px solid #eee",
            borderRight: "1px solid #eee",
          }}>
          <h5 style={{ fontSize: 18, color: "red" }}>Thông tin phát</h5>
          <InfoField
            title="Trạng thái"
            value={packageInfo?.phat?.trang_thai || ""}
          />
          <InfoFieldPostOffice
            title="Bưu cục phát"
            value={packageInfo?.phat?.vi_tri || ""}
            onClickPostOffice={
              ringmeOttSdk
                ? (postOffice) =>
                    handleChatToPostOffice(
                      postOffice,
                      packageInfo?.ott?.jqid_buu_cuc_phat
                    )
                : null
            }
          />
          <InfoField
            title="Ngày nhập"
            value={packageInfo?.phat?.ngay_nhap || ""}
          />
          <InfoField
            title="Ngày phát"
            value={packageInfo?.phat?.ngay_phat || ""}
          />
        </Grid>
        <Grid
          item
          md={3}
          xs={12}
          style={{
            borderRight: "1px solid #eee",
            borderTop: "1px solid #eee",
          }}>
          <h5 style={{ fontSize: 18, color: "red" }}>Thông tin bưu tá</h5>
          <InfoField
            title="Tên bưu tá gom"
            value={packageInfo?.postman?.ten_buu_ta_gom || ""}
          />
          <InfoFieldPhoneNumber
            title="Số điện thoại bưu tá gom"
            value={packageInfo?.postman?.sdt_buu_ta_gom || ""}
            onClickPhoneNumber={ringmeOttSdk ? handleChatToPhoneNumber : null}
          />
          <InfoField
            title="Tên bưu tá phát"
            value={packageInfo?.postman?.ten_buu_ta_phat || ""}
          />
          <InfoFieldPhoneNumber
            title="Số điện thoại bưu tá phát"
            value={packageInfo?.postman?.sdt_buu_ta_phat || ""}
            onClickPhoneNumber={ringmeOttSdk ? handleChatToPhoneNumber : null}
          />
        </Grid>

        <Grid item md={12} style={{ border: "1px solid #eee" }}>
          <h5 style={{ fontSize: 18, color: "red" }}>Thông tin định vị</h5>
          <Table>
            <TableHead>
              <TableCell>Ngày</TableCell>
              <TableCell>Giờ</TableCell>
              <TableCell>Trạng thái</TableCell>
              <TableCell>Vị trí</TableCell>
            </TableHead>
            <TableBody>
              {packageInfo?.dinhvi?.map((item, index) => (
                <TableRow key={index}>
                  <TableCell>{item.ngay}</TableCell>
                  <TableCell>{item.gio}</TableCell>
                  <TableCell>
                    {item.trang_thai} - {item.text_trang_thai}
                  </TableCell>
                  <TableCell>{item.vi_tri}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Grid>
      </Grid>
    </DialogDragable>
  );
};

const InfoField = ({ title, value }) => (
  <div style={{ marginBottom: 3 }}>
    <span style={{ fontWeight: 600 }}>{title}</span>: <span>{value}</span>
  </div>
);

const InfoFieldPhoneNumber = ({ title, value, onClickPhoneNumber }) => {
  return (
    <div style={{ marginBottom: 3 }}>
      <span style={{ fontWeight: 600 }}>{title}</span>:{" "}
      {value && onClickPhoneNumber && (
        <Tooltip title="Nhắn tin cho SĐT này">
          <span
            onClick={() => onClickPhoneNumber(value)}
            style={{ cursor: "pointer", color: "orange", fontWeight: "bold" }}>
            {value}
          </span>
        </Tooltip>
      )}
      {value && !onClickPhoneNumber && <span>{value}</span>}
    </div>
  );
};

const InfoFieldPostOffice = ({ title, value, onClickPostOffice }) => {
  return (
    <div style={{ marginBottom: 3 }}>
      <span style={{ fontWeight: 600 }}>{title}</span>:{" "}
      {value && onClickPostOffice && (
        <Tooltip title="Nhắn tin cho bưu cục này">
          <span
            onClick={() => onClickPostOffice(value)}
            style={{ cursor: "pointer", color: "orange", fontWeight: "bold" }}>
            {value}
          </span>
        </Tooltip>
      )}
      {value && !onClickPostOffice && <span>{value}</span>}
    </div>
  );
};

export default PackageInfo;
